// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-about-js": function componentSrcPagesAboutJs() {
    return import("./../../src/pages/about.js"
    /* webpackChunkName: "component---src-pages-about-js" */
    );
  },
  "component---src-pages-contact-js": function componentSrcPagesContactJs() {
    return import("./../../src/pages/contact.js"
    /* webpackChunkName: "component---src-pages-contact-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-no-category-found-js": function componentSrcPagesNoCategoryFoundJs() {
    return import("./../../src/pages/noCategoryFound.js"
    /* webpackChunkName: "component---src-pages-no-category-found-js" */
    );
  },
  "component---src-pages-posts-js": function componentSrcPagesPostsJs() {
    return import("./../../src/pages/posts.js"
    /* webpackChunkName: "component---src-pages-posts-js" */
    );
  },
  "component---src-pages-team-js": function componentSrcPagesTeamJs() {
    return import("./../../src/pages/team.js"
    /* webpackChunkName: "component---src-pages-team-js" */
    );
  },
  "component---src-templates-author-posts-js": function componentSrcTemplatesAuthorPostsJs() {
    return import("./../../src/templates/authorPosts.js"
    /* webpackChunkName: "component---src-templates-author-posts-js" */
    );
  },
  "component---src-templates-category-post-js": function componentSrcTemplatesCategoryPostJs() {
    return import("./../../src/templates/categoryPost.js"
    /* webpackChunkName: "component---src-templates-category-post-js" */
    );
  },
  "component---src-templates-post-list-js": function componentSrcTemplatesPostListJs() {
    return import("./../../src/templates/postList.js"
    /* webpackChunkName: "component---src-templates-post-list-js" */
    );
  },
  "component---src-templates-single-post-js": function componentSrcTemplatesSinglePostJs() {
    return import("./../../src/templates/singlePost.js"
    /* webpackChunkName: "component---src-templates-single-post-js" */
    );
  },
  "component---src-templates-tag-post-js": function componentSrcTemplatesTagPostJs() {
    return import("./../../src/templates/tagPost.js"
    /* webpackChunkName: "component---src-templates-tag-post-js" */
    );
  }
};